<template>
  <div class="app-root" @click="onFirstGesture" @keydown="onFirstGesture">
    <OrientationNudge v-if="!isLandscape" />
    <RouterView />
    <Toast />
  </div>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import Toast from '@/components/interface/Toast.vue'
import { useHelpers } from '@/composables/useHelpers'
import { AppWindowEvent } from '@/types/Events'
import { useOrientation } from '@/composables/useOrientation'
import OrientationNudge from './components/interface/OrientationNudge.vue'
import { useSound } from '@/composables/useSound'
import { useGameStore } from '@/stores/game'
import { storeToRefs } from 'pinia'

const { sendParentWindowMessage } = useHelpers()
const { isLandscape, startOrientationListener, attemptLockLandscape } = useOrientation()
const { playAmbientSound, setAmbientVolume } = useSound()
const { gamePhase } = storeToRefs(useGameStore())

const onFirstGesture = () => {
  // Try to lock when the user first interacts
  attemptLockLandscape()
  playAmbientSound()
}

watch(gamePhase, newPhase => {
  if (newPhase === 'GAME_PLAY_PHASE') {
    setAmbientVolume(0.15)
  } else {
    setAmbientVolume(0.3)
  }
})

onMounted(() => {
  sendParentWindowMessage(AppWindowEvent.GameLoaded)
  startOrientationListener()
})
</script>

<style scoped>
.app-root {
  position: relative;
  min-height: 100dvh;
}
</style>
